/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Tags_Close_FireInputs */

const en_control_tags_close_fire = /** @type {(inputs: Control_Tags_Close_FireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short-range fire`)
};

const zh_control_tags_close_fire = /** @type {(inputs: Control_Tags_Close_FireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近距离火焰`)
};

/**
* | output |
* | --- |
* | "Short-range fire" |
*
* @param {Control_Tags_Close_FireInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_tags_close_fire = /** @type {((inputs?: Control_Tags_Close_FireInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Tags_Close_FireInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_tags_close_fire(inputs)
	return zh_control_tags_close_fire(inputs)
});
export { control_tags_close_fire as "control.tags.close_fire" }